import type { MetaFunction } from "@remix-run/node";
import { Outlet } from "@remix-run/react";
import type { SitemapFunction } from "remix-sitemap";

import { Button } from "~/components/ui/button";
import { PageContainer } from "~/components/ui/layout/page-container";
import { Wrapper } from "~/components/ui/layout/wrapper";
import { PageHeading } from "~/components/ui/page-heading";
import { SidebarLayout } from "~/components/ui/sidebar";
import { faqData } from "~/config/faq";
import { getSeoMeta } from "~/utils/seo";

export const sitemap: SitemapFunction = () => ({
  exclude: true,
});

export const meta: MetaFunction = (metaArgs) => {
  return getSeoMeta(metaArgs, {
    title: `FAQ - Questions les plus fréquemment posées`,
    description: `Consultez les réponses aux questions les plus fréquemment posées par nos clients.`,
  });
};

const breadcrumbData = [
  {
    name: "FAQ",
    slug: "",
  },
];

const FAQLayout = () => {
  const navbarData = faqData.map((item) => ({
    label: item.categoryLabel,
    to: item.categorySlug,
  }));

  return (
    <SidebarLayout navItems={navbarData} navbarClassName="">
      <PageContainer>
        <PageHeading headingText="FAQ" breadcrumbData={breadcrumbData} />
        <Wrapper>
          <p className="mb-12">
            Vous avez des interrogations ? Consultez les réponses aux questions les plus
            fréquemmmment posées par nos clients.
          </p>
          <Outlet />
          <p className="mb-6 mt-16 font-medium text-grey-600">
            Vous n&apos;avez pas trouvé de réponse à votre question ?
          </p>
          <Button as="link" to="/nous-contacter">
            Contactez-nous
          </Button>
        </Wrapper>
      </PageContainer>
    </SidebarLayout>
  );
};

export default FAQLayout;
